<nz-select nz-input [(ngModel)]="value" [nzDropdownMatchSelectWidth]="false" (ngModelChange)="onModelChange($event)"
  nzAllowClear="false">
  <nz-option [nzValue]="item.value" [nzLabel]="item.label" *ngFor="let item of options"></nz-option>
</nz-select>